/* eslint-disable no-unused-vars */
import moment from "moment";

export const GenderHandler = (value) => {
  if (value === 0) {
    return "Male";
  } else if (value === 1) {
    return "Female";
  } else if (value === 2) {
    return "Other";
  } else {
    return "Prefer not to say";
  }
};

export const UserTypeHandler = (value) => {
  if (value === 0) {
    return "Site Staff";
  } else if (value === 1) {
    return "Office Staff";
  } else if (value === 2) {
    return "Admin";
  } else {
    return "";
  }
};

export const employeeStatusHandler = (value) => {
  if (value === "current") {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">
        Current
      </span>
    );
  } else if (value === "risigned") {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">Resigned</span>
    );
  } else if (value === "exEmployee") {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">
        Ex-Employee
      </span>
    );
  } else if (value === "transfer") {
    return (
      <span className="badge bg-aqua-25 fw-normal rounded-pill">
        Transfer
      </span>
    );
  } else if (value === "terminated") {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">
        Terminated
      </span>
    );
  }
};

export const handleWorkOrderStatus = (status) => {
  if (status === true) {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">
        Completed
      </span>
    );
  } else {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">
        Pending
      </span>
    );
  }
};

export const handleTaskStatus = (status) => {
  if (status === "To Do") {
    return (
      <span className="badge bg-light text-secondary border border-secondary-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        To Do
      </span>
    );
  } else if (status === "In Progress") {
    return (
      <span className="badge bg-primary-subtle text-primary border border-primary-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        In Progress
      </span>
    );
  } else if (status === "Done") {
    return (
      <span className="badge bg-success-subtle text-success border border-success-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        Done
      </span>
    );
  } else if (status === "Cancelled") {
    return (
      <span className="badge bg-danger-subtle text-danger border border-danger-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        Cancelled
      </span>
    );
  }
};

export const handlePriorityStatus = (status) => {
  if (status === "low") {
    return (
      <span className="badge bg-success-subtle text-success border border-success-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        Low
      </span>
    );
  } else if (status === "medium") {
    return (
      <span className="badge bg-warning-subtle text-warning border border-warning-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        Medium
      </span>
    );
  } else if (status === "high") {
    return (
      <span className="badge bg-danger-subtle text-danger border border-danger-subtle fw-bold rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1" style={{ fontSize: "10px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg>
        High
      </span>
    );
  }
};

export const handleStatus = (status) => {
  if (status === 0) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">
        Pending
      </span>
    );
  } else if (status === 1) {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">
        Approved
      </span>
    );
  } else if (status === 2) {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">Rejected</span>
    );
  }
};

export const handleBudgetRequestStatus = (status) => {
  if (status === "pending") {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">
        Pending
      </span>
    );
  } else if (status === "approved") {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">
        Approved
      </span>
    );
  } else if (status === "rejected") {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">Rejected</span>
    );
  } else if (status === "Director Created") {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">
        Director Created
      </span>
    );
  }
};

export const handleAttendanceStatus = (status) => {
  if (status === 0) {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">Absent</span>
    );
  } else if (status === 1) {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">Present</span>
    );
  } else if (status === 2) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">Pending</span>
    );
  } else if (status === 3) {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">On Leave</span>
    );
  } else if (status === 4) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">Pending Leave</span>
    );
  } else if (status === 5) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">Pending AR</span>
    );
  } else if (status === 6) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">Pending OD</span>
    );
  } else if (status === 7) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">Weekly Off</span>
    );
  } else if (status === 8) {
    return (
      <span className="badge bg-green-25 fw-normal rounded-pill">WFH</span>
    );
  } else if (status === 9) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">Pending WFH</span>
    );
  }
  else if (status === 10) {
    return (
      <span className="badge bg-info-25 fw-normal rounded-pill">Comp Off</span>
    );
  }
};

// export const handleAttendanceStatusDropdown = (status, onChange, id) => {
//   const getClassName = () => {
//     switch (status) {
//       case 1:
//         return "text-success";
//       case 0:
//         return "text-danger";
//       case 2:
//         return "text-warning";
//       case 3:
//         return "text-info";
//       default:
//         return "";
//     }
//   };

//   return (
//     <td>
//       <select
//         className={`form-select fw-medium rounded-4 ${getClassName()}`}
//         value={status}
//         onChange={(e) => onChange(id, Number(e.target.value))}
//       >
//         <option value={1}>Present</option>
//         <option value={0}>Absent</option>
//         <option value={2}>Pending</option>
//         <option value={3}>On Leave</option>
//       </select>
//     </td>
//   );
// };

export function convertTime() {
  const currentISTTime = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(new Date());

  return currentISTTime.replace(/\//g, "-");
}

export function calculateHours(checkInTime, checkOutTime) {
  // Validate check-in time
  if (!checkInTime) {
    return "00:00";
  }

  // Use Moment to parse check-in time in local time
  const start = moment(checkInTime);

  // If check-out time is provided, use it; otherwise, use the current time in IST
  let end = moment();
  if (checkOutTime) {
    end = moment(checkOutTime);
  } else {
    // If no checkout time is provided, set the current time in IST manually
    const istOffset = 5.5 * 60; // IST is UTC +5:30
    const currentTimeInUTC = moment.utc();
    end = currentTimeInUTC.clone().add(istOffset, "minutes");
  }

  // Handle cases where checkout is before check-in (e.g., past midnight)
  if (end.isBefore(start)) {
    end.add(1, "day"); // Add 1 day if checkout is before check-in
  }

  // Calculate duration
  const duration = moment.duration(end.diff(start));

  // Extract hours and minutes
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  // Format as HH:MM
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}

export const getMonthStartEnd = (selectedDate) => {
  const start = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    1,
  );
  const end = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth() + 1,
    0,
  );
  return { start, end };
};

export function getMonthDates(monthYear) {
  const startDate = moment(monthYear, "YYYY-MM")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endDate = moment(monthYear, "YYYY-MM")
    .endOf("month")
    .format("YYYY-MM-DD");

  return { startDate, endDate };
}

export function formatTo12HourTime(dateString) {
  const date = new Date(dateString);

  // Get hours and minutes from UTC time
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  // Determine AM/PM
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert 24-hour to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // Handle the case of 0 hours (midnight)

  // Format the time in hh:mm AM/PM
  return `${ampm === `AM` ? (hours === 12 ? "00" : hours) : hours
    }:${minutes} ${ampm}`;
}

export function isEndDateGreater(endDateStr) {
  // Parse the end date with flexible parsing
  const endDate = moment(endDateStr, moment.ISO_8601, true); // Try ISO format first

  // console.log(endDate);

  // If parsing failed, attempt without strict ISO
  if (!endDate.isValid()) {
    throw new Error("Invalid date format. Please provide a valid date.");
  }

  // Get today's date (start of the day)
  const today = moment().startOf("day"); // Midnight of today

  // Compare endDate with today
  return endDate.isAfter(today);
}

export function getCurrentAddress() {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            // Fetch the address from Google Geocoding API
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${import.meta.env.VITE_APP_API_KEY}`,
            );
            const data = await response.json();

            if (data.status === "OK" && data.results.length > 0) {
              const currentAddress = data.results[0].formatted_address;
              resolve({ latitude, longitude, currentAddress });
            } else {
              reject(new Error("Unable to fetch address from the API."));
            }
          } catch (error) {
            console.error("Error fetching address:", error);
            reject(new Error("An error occurred while fetching the address."));
          }
        },
        (error) => {
          // Handle Geolocation API errors
          switch (error.code) {
            case error.PERMISSION_DENIED:
              reject(new Error("User denied the request for Geolocation."));
              break;
            case error.POSITION_UNAVAILABLE:
              reject(new Error("Location information is unavailable."));
              break;
            case error.TIMEOUT:
              reject(new Error("The request to get user location timed out."));
              break;
            default:
              reject(new Error("An unknown error occurred."));
              break;
          }
        },
        {
          enableHighAccuracy: true, // Use GPS if available
          timeout: 10000, // Timeout after 10 seconds
          maximumAge: 0, // Prevent cached location
        },
      );
    } else {
      reject(new Error("Geolocation is not supported by this browser."));
    }
  });
}

export function getCurrentLocation() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ latitude, longitude, status: true });
        },
        (error) => {
          reject({
            error: true,
            message: `Error Code: ${error.code}, Message: ${error.message}`,
          });
        },
      );
    } else {
      reject({
        error: true,
        message: "Geolocation is not supported by this browser.",
      });
    }
  });
}

export function CalculateDuration(fromDate, toDate) {
  const from = new Date(fromDate);
  const to = toDate ? new Date(toDate) : new Date();

  // Calculate the difference in total months
  const years = to.getFullYear() - from.getFullYear();
  const months = to.getMonth() - from.getMonth();

  // Calculate total months difference
  const totalMonths = years * 12 + months;

  // If duration is less than 12 months, return in months
  if (totalMonths < 12) {
    return `${totalMonths} month${totalMonths > 1 ? "s" : ""}`;
  }

  // Otherwise, return in years and months
  const remainingMonths = totalMonths % 12;
  const fullYears = Math.floor(totalMonths / 12);
  return `${fullYears} year${fullYears > 1 ? "s" : ""} ${remainingMonths > 0
    ? `${remainingMonths} month${remainingMonths > 1 ? "s" : ""}`
    : ""
    }`;
}

export function checkUserAccess(userData, type = null) {
  // console.log("userDataaaaaaaaa",userData?.type);
  if (userData?.type === 2) {
    return { isUserAccess: true };
  }
  if (
    userData?.type === 1 &&
    userData?.designation?.name === "HOD" &&
    userData?.department?.name === "HRM"
  ) {
    return { isUserAccess: true };
  } else if (userData?.type === 1 && userData?.designation?.name === "Sr. HR") {
    return { isUserAccess: true };
  } else if (
    userData?.type === 1 &&
    userData?.designation?.name === "Director" &&
    userData?.department?.name === "Management"
  ) {
    return { isUserAccess: true };
  } else if (userData?.type === 1 && userData?.designation?.name === "Jr. HR") {
    return { isUserAccess: true };
  } else {
    return { isUserAccess: false };
  }
}

export function checkTeamAccess(userData) {
  // console.log("userDataaaaaaaaa",userData?.type);
  if (userData?.type === 2) {
    return { isTeamAccess: true };
  } else if (
    userData?.type == 0 &&
    (userData?.designation?.name == "Plant Head" ||
      userData?.designation?.name == "Site SCM")
  ) {
    return { isTeamAccess: true };
  } else if (
    userData?.type == 1 &&
    (userData?.department?.name == "HRM" ||
      userData?.department?.name == "Solar / Wind" ||
      userData?.department?.name == "GSS / TL")
  ) {
    return { isTeamAccess: true };
  }
}

export function calculateDaysDifference(date1, date2, type = null) {
  // Convert inputs to Date objects if they are strings
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Validate the dates
  if (isNaN(d1) || isNaN(d2)) {
    // throw new Error("Invalid date format. Please provide valid dates.");
    return;
  }

  // Calculate the difference in milliseconds
  const diffInMilliseconds = Math.abs(d2 - d1);

  // Convert milliseconds to days and add 1 to include the extra day
  let days = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24)) + 1;

  // Return the adjusted days, or an empty string if the result is 0
  return days === 0 ? "" : type ? days : `${days} days`;
}

/**
 * The function `toRadians` converts degrees to radians in JavaScript.
 * @param degree - The `toRadians` function takes a degree value as input and converts it to radians.
 * @returns The function `toRadians` takes a degree value as input and returns the equivalent value in
 * radians.
 */
function toRadians(degree) {
  return (degree * Math.PI) / 180;
}

export function isWithinRadius(lat1, lon1, lat2, lon2, radiusInMeters) {
  const R = 6371000; // Earth's radius in meters

  const deg2rad = (deg) => (deg * Math.PI) / 180;

  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
    Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const aerialDistance = R * c;
  // console.log("Distance", aerialDistance);

  return aerialDistance <= radiusInMeters;
}

export function formatNumber(num) {
  return num % 1 === 0 ? num.toFixed(0) : num.toString();
}

export const generateYearRanges = () => {
  const currentYear = new Date().getFullYear(); // Get the current year
  const numberOfYears = 2; // Number of year ranges to show (last year + current year)
  const yearRanges = [];

  for (let i = 0; i < numberOfYears; i++) {
    const startYear = currentYear - (numberOfYears - 1) + i; // Start year for each range
    const endYear = startYear + 1; // End year for each range
    yearRanges.push(`${startYear} - ${endYear}`);
  }

  return yearRanges;
};

export const getLastMonthsRanges = (months) => {
  const today = new Date();
  const currentYear = today.getFullYear();

  if (months === "current") {
    return {
      start: new Date(currentYear, 0, 1), // January 1st
      end: new Date(currentYear, 11, 31), // December 31st
    };
  }

  if (months === "Last") {
    return {
      start: new Date(currentYear - 1, 0, 1), // January 1st of last year
      end: new Date(currentYear - 1, 11, 31), // December 31st of last year
    };
  }

  const numMonths = Number(months);
  const startOfRange = new Date(
    today.getFullYear(),
    today.getMonth() - numMonths,
    1,
  );
  const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month

  return {
    start: startOfRange,
    end: endOfLastMonth,
  };
};

export function getInitials(fullName) {
  if (!fullName || typeof fullName !== "string") return ""; // Handle undefined, null, or non-string values

  const words = fullName.trim().split(" ");
  if (words.length < 2) return fullName.charAt(0).toUpperCase(); // If only one name exists

  const firstInitial = words[0].charAt(0).toUpperCase();
  const secondInitial = words[1].charAt(0).toUpperCase();

  return firstInitial + secondInitial;
}
// export function getInitials(fullName) {
//   // Extract the first character of the first word and the first character of the second word
//   const words = fullName.split(" ");
//   if (words.length < 2) return fullName.charAt(0).toUpperCase(); // Handle cases where only one name exists
//   const firstInitial = words[0].charAt(0).toUpperCase();
//   const secondInitial = words[1].charAt(0).toUpperCase();
//   return firstInitial + secondInitial;
// }

export function withInShift(userDetails, currentTime) {
  const shiftStart = moment(userDetails?.Shift?.startTime, "HH:mm");
  const shiftEnd = moment(userDetails?.Shift?.endTime, "HH:mm");
  const isWithin = currentTime.isBetween(shiftStart, shiftEnd, null, "[]");

  return isWithin ? { isWithin: true } : { isWithin: false };
}

export function timeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  for (let interval of intervals) {
    const count = Math.floor(seconds / interval.seconds);
    if (count >= 1) {
      return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
    }
  }

  return "just now";
}

export const useAttendanceStatus = (attendanceData) => {
  if (attendanceData?.status === 3) {
    return <p className="text-danger">You are on leave today</p>;
  } else if (attendanceData?.isODrequest) {
    return <p className="text-danger">Od Request</p>;
  } else if (attendanceData?.isARrequest) {
    return <p className="text-danger">AR Request</p>;
  } else if (attendanceData?.markOverTime) {
    return <p className="text-danger">Your Extra Time is Running..</p>;
  }
};

export const HandlePurchaseRequestStatus = (status) => {
  if (status === "pending") {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">
        {status}
      </span>
    );
  }
  if (typeof status === "string" && status.toLowerCase().includes("hold")) {
    return (
      <span className="badge bg-yellow-25 fw-normal rounded-pill">
        {status}
      </span>
    );
  }
  const rejectedStatuses = [
    "Plant Head Rejected",
    "Zonal Head Rejected",
    "Director Rejected",
    "Admin Rejected",
    "Finance Rejected",
    "SCM Rejected",
    "HOD Rejected",
    "PO Short Closed",
  ];
  if (rejectedStatuses.includes(status)) {
    return (
      <span className="badge bg-red-25 fw-normal rounded-pill">{status}</span>
    );
  }
  return (
    <span className="badge bg-green-25 fw-normal rounded-pill">{status}</span>
  );
};

export const formatAmount = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(amount);
};

export const parseAmount = (formattedAmount) => {
  if (typeof formattedAmount === "number") return formattedAmount;

  if (!formattedAmount || typeof formattedAmount !== "string") return 0;

  // Remove ₹ and commas
  const numericString = formattedAmount.replace(/[₹,]/g, "");
  return parseFloat(numericString);
};

export const handleUnderInBudget = (amount, budget, setState) => {
  const difference = budget - amount;

  return {
    underBudget: amount <= budget,
    difference: difference,
  };
};

export function calculateTotalAmount(qty, pricePerUnit, gstRate) {
  if (
    isNaN(qty) ||
    isNaN(pricePerUnit) ||
    isNaN(gstRate) ||
    qty <= 0 ||
    pricePerUnit < 0 ||
    gstRate < 0
  ) {
    return "Invalid input";
  }
  // printData(gstRate);

  let amount = qty * pricePerUnit; // Total amount before GST
  let gstAmount = (amount * gstRate) / 100; // GST amount
  let totalAmount = amount + gstAmount; // Total amount including GST

  return {
    amount: amount.toFixed(2), // Amount before GST
    gstAmount: gstAmount.toFixed(2), // GST amount
    totalAmount: totalAmount.toFixed(2), // Final amount after GST
  };
}

export function printData(type, data) {
  // console.log(type, data);
}

export const getCurrentFinancialYear = () => {
  const today = moment();
  const startYear = today.month() < 3 ? today.year() - 1 : today.year();
  //current year
  return `${startYear}-${startYear + 1}`;
  //2024-2025
  // return `${startYear - 1}-${startYear}`;
};

export const shouldShowApproveRejectButtons = (
  userDetails,
  state,
  location,
  dataLoading,
) => {
  const ticket = state?.paymentTicketData;

  if (
    dataLoading ||
    !location?.state?.isPending ||
    userDetails?.id === ticket?.userId ||
    userDetails?.type === 2 ||
    ticket?.status?.split(" ")?.includes("Rejected")
  ) {
    return false;
  }

  const isPending = ticket?.status === "pending";

  const isPlantHeadToZonalHead =
    isPending &&
    ticket?.user?.designation?.name === "Plant Head" &&
    userDetails?.designation?.name === "Zonal Head";

  const isZonalHeadToHOD =
    isPending &&
    ticket?.user?.designation?.name === "Zonal Head" &&
    userDetails?.designation?.name === "HOD" &&
    ["Solar / Wind", "GSS / TL"].includes(userDetails?.department?.name);

  const isHODToSCM =
    isPending &&
    ticket?.user?.designation?.name === "HOD" &&
    ["Solar / Wind", "GSS / TL"].includes(ticket?.user?.department?.name) &&
    userDetails?.department?.name === "SCM" &&
    userDetails?.type === 1;

  const isSCMToAccount =
    isPending &&
    ticket?.user?.department?.name === "SCM" &&
    userDetails?.department?.name === "Account" &&
    userDetails?.type === 1;

  const isHRMToAccount =
    isPending &&
    ticket?.user?.department?.name === "HRM" &&
    userDetails?.department?.name === "Account" &&
    userDetails?.type === 1;

  const isPlantHeadApprovedFlow =
    ticket?.status === "Plant Head Approved" &&
    userDetails?.designation?.name === "Zonal Head";

  const isZonalHeadApprovedFlow =
    ticket?.status === "Zonal Head Approved" &&
    userDetails?.designation?.name === "HOD" &&
    ["Solar / Wind", "GSS / TL"].includes(userDetails?.department?.name);

  const isHODApprovedToSCM =
    ticket?.status === "HOD Approved" &&
    ["Plant Head", "Zonal Head"].includes(ticket?.user?.designation?.name) &&
    userDetails?.department?.name === "SCM" &&
    userDetails?.type === 1;

  const isSCMApprovedToAccount =
    ticket?.status === "SCM Approved" &&
    ticket?.status !== "Finance Approved" &&
    userDetails?.department?.name === "Account" &&
    userDetails?.type === 1;

  return (
    isPlantHeadToZonalHead ||
    isZonalHeadToHOD ||
    isHODToSCM ||
    isSCMToAccount ||
    isHRMToAccount ||
    isPlantHeadApprovedFlow ||
    isZonalHeadApprovedFlow ||
    isHODApprovedToSCM ||
    isSCMApprovedToAccount
  );
};

export const UnitCollection = [
  { value: "kg", label: "Kg" },
  { value: "ltr", label: "Ltr" },
  { value: "man", label: "Man" },
  { value: "nos", label: "Nos" },
  { value: "ton", label: "Ton" },
  { value: "quintal", label: "Quintal" },
  { value: "mt", label: "MT" },
  { value: "mtr", label: "Mtr" },
  { value: "acre", label: "Acre" },
  { value: "gaj", label: "Gaj" },
  { value: "sqft", label: "Sqft" },
  { value: "sqmtr", label: "Sqmtr" },
  { value: "ft", label: "Ft" },
  { value: "fix", label: "Fixed" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" },
  { value: "au", label: "AU" },
  { value: "ls", label: "LS" },
  { value: "ea", label: "EA" },
];

export const getAccessCreateGrn = (userDetails) => {
  if (
    (userDetails?.type == 1 && userDetails?.department === "SCM") ||
    userDetails?.designation?.name === "Site SCM" ||
    userDetails?.designation?.name == "Plant Head"
  ) {
    return {
      isAccess: true,
    };
  } else {
    return {
      isAccess: false,
    };
  }
};

export const RenderDocumentPreview = (selectedDocument) => {
  // console.log("selectedDocument=====",selectedDocument)
  if (!selectedDocument) return null;

  const fileExtension = selectedDocument?.name
    ? selectedDocument?.name?.split(".")?.pop()?.toLowerCase()
    : selectedDocument?.url?.split(".")?.pop()?.toLowerCase();

  const url = selectedDocument?.name
    ? URL.createObjectURL(selectedDocument)
    : selectedDocument?.url;

  switch (fileExtension) {
    case "jpg":
      return (
        <img
          src={url}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    case "svg":
      return (
        <img
          src={url}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    case "jpeg":
      return (
        <img
          src={url}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    case "png":
      return (
        <img
          src={url}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    case "gif":
      return (
        <img
          src={url}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    case "webp":
      return (
        <img
          src={url}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    case "pdf":
      return (
        <iframe
          src={url}
          width="100%"
          height="500px"
          title="Document Preview"
        ></iframe>
      );
    case "txt":
      return (
        <textarea
          readOnly
          value={selectedDocument?.content} // Assuming `content` is the file content
          style={{ width: "100%", height: "500px" }}
        />
      );
    case "docx":
      return (
        <div>
          {/* Handle DOCX preview (you can integrate a library like `react-doc-viewer`) */}
          <p>DOCX preview not supported in browser directly.</p>
        </div>
      );
    default:
      return <p>Unsupported file type</p>;
  }
};

export default function calculateFinancialYears(startDate, endDate) {
  if (!startDate || !endDate) return [];

  const start = new Date(startDate);
  const end = new Date(endDate);

  const getFYStartYear = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return month >= 4 ? year : year - 1;
  };

  let fyStart = getFYStartYear(start);
  let fyEnd = getFYStartYear(end);

  const result = [];
  for (let year = fyStart; year <= fyEnd; year++) {
    result.push(`${year}-${year + 1}`);
  }

  return result;
}

export const getTotalAmount = (data, type) => {
  const quantity = parseFloat(data?.updatedQuantity) || 0;
  const rate = parseFloat(data?.rate) || 0;
  const month = parseFloat(data?.month) || 0;

  return type === "serviceRequest" && month
    ? quantity * rate * month
    : quantity * rate;
};


export const resolvePaymentStatusCode = (item) => {
  const rawStatus =
    item?.paymentStatus ??
    item?.payment_status ??
    item?.paymentState ??
    item?.payStatus ??
    "";

  if (typeof rawStatus === "number" && rawStatus >= 0 && rawStatus <= 3) {
    return rawStatus;
  }

  const apiStatus = String(rawStatus)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  if (
    apiStatus === "completed" ||
    apiStatus === "fullpayment" ||
    apiStatus === "full"
  ) {
    return 1;
  }
  if (
    apiStatus === "partial" ||
    apiStatus === "partpayment" ||
    apiStatus === "part"
  ) {
    return 2;
  }
  if (apiStatus === "inprogress") return 3;
  if (apiStatus === "pending") return 0;

  const total =
    parseAmount(item?.totalAmount) || Number(item?.totalAmount) || 0;
  const remaining =
    parseAmount(item?.remainingAmount) || Number(item?.remainingAmount) || 0;
  const paid = total - remaining;

  if (total <= 0) return 0;
  if (paid <= 0.01 || remaining >= total - 0.01) return 0;
  if (remaining <= 0.01 || paid >= total - 0.01) return 1;
  return 2;
};

export const sumTicketAmounts = (tickets = []) =>
  tickets.reduce(
    (acc, item) => {
      const total = Number(item?.totalAmount) || 0;
      const remaining = Number(item?.remainingAmount) || 0;
      const paid = total - remaining;

      acc.count += 1;
      acc.totalAmount += total;
      acc.totalPaid += paid;
      acc.totalRemaining += remaining;
      return acc;
    },
    { count: 0, totalAmount: 0, totalPaid: 0, totalRemaining: 0 }
  );

export const indianStates = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal"
];